module.exports = __webpack_public_path__ + "travel_adventure-theme-park_1.jpg";